<template>
  <v-card width="450">
    <v-card-title primary-title>
      <v-icon size="36">layers</v-icon>
      <div>
        <div class="headline mb-3">{{ messageGeofence.title }}</div>
        <span>
         {{ messageGeofence.content }}
        </span>
        <ul v-if="messageGeofence.type === 'related-mission'" class="mt-2">
          <li v-for="(missionName, index) in messageGeofence.missions" :key="index">
            {{ missionName }}
          </li>
        </ul>
      </div>
    </v-card-title>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        color="error"
        @click="closeMessage"
      >
        <v-icon left>clear</v-icon>
        <div v-if="messageGeofence.type === 'active-mission'">Cerrar</div>
        <div v-else>Cancelar</div>
      </v-btn>
      <v-btn
        v-if="messageGeofence.type === 'related-mission' && !messageGeofence.toUpdate"
        color="primary"
        @click="continueEditGeofence"
      >
        <v-icon left>mode_edit</v-icon>
        Continuar Editando
      </v-btn>
      <v-btn
        v-else-if="messageGeofence.type === 'related-mission' && messageGeofence.toUpdate"
        color="primary"
        @click="updateGeofence"
      >
        Actualizar
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import { editGeofenceMixin } from '../../mixins/editGeofenceMixin'

  export default {
    name: 'edit-geofence-message',
    props: {
      editedPath: {
        type: Array,
        required: true
      }
    },
    mixins: [editGeofenceMixin],
    computed: {
      ...mapGetters(['messageGeofence']),
      ...mapGetters({
        selectedGeofence: 'getSelectedGeofence'
      })
    },
    methods: {
      ...mapActions([
        'setShowMessageGeofence',
        'showCreateEditGeofenceAction',
        'setEditingGeofence'
      ]),
      continueEditGeofence() {
        this.setShowMessageGeofence(false)
        this.showCreateEditGeofenceAction(true)
        this.setEditingGeofence(true)
        // console.log('continueEditGeofence:', this.selectedGeofence)
        this.$emit('centerPolygon', this.selectedGeofence)
      },
      closeMessage() {
        if (
          this.messageGeofence.type === 'related-mission' &&
          this.messageGeofence.toUpdate
        ) {
          this.showCreateEditGeofenceAction(false)
          this.setEditingGeofence(false)
          this.$emit('cancelEdit')
        } else {
          this.$emit('clearFenceSelected')
        }
        this.setShowMessageGeofence(false)
      },
      updateGeofence() {
        this.isUpdatingFence = true
        this.setShowMessageGeofence(false)
        this.updateGeofenceFromMessage(this.editedPath)
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/Geofence/EditGeofenceMessage.vue